// extracted by mini-css-extract-plugin
export var favorite = "styles-module__favorite___H4gJe";
export var header = "styles-module__header___S68w3";
export var icon = "styles-module__icon___QilQJ";
export var iconText = "styles-module__icon-text___QvOBY";
export var noResults = "styles-module__noResults___toAvA";
export var noResultsButton = "styles-module__noResultsButton___WvcyT";
export var recordings = "styles-module__recordings___WUcse";
export var searching = "styles-module__searching___bdp6I";
export var trailpost = "styles-module__trailpost___d_geb";